import type { TimeSeries, TimeSeriesPoint } from './time-series.types';

const PERIODS = [
  '2023.1Q',
  '2023.2Q',
  '2023.3Q',
  '2023.4Q',
  '2024.1Q',
  '2024.2Q',
  '2024.3Q',
  '2024.4Q',
] as const;

const toPoints = (values: readonly (number | null)[]): TimeSeriesPoint[] =>
  PERIODS.map((label, index) => ({ label, value: values[index] ?? null }));

/** Figma 예시(TimeSeriesChart 2047:12756)와 같은 자료. 기간 8개 2023.1Q ~ 2024.4Q, 금액은 백만원 */
export const timeSeriesFixture = {
  revenue: [
    { label: '매출', points: toPoints([820, 1150, 1390, 1720, 1980, 2410, 2960, 3636]) },
    { label: '영업이익', points: toPoints([40, 95, 160, 240, 330, 450, 610, 780]) },
  ],
  cash: [
    { label: '현금성 자산', points: toPoints([4200, 3800, 3300, 5900, 5400, 4900, 4300, 7273]) },
  ],
  employ: [
    { label: '39세 이하', points: toPoints([12, 14, 17, 19, 22, 25, 27, 29]) },
    { label: '총 고용 인원', points: toPoints([18, 21, 25, 28, 33, 37, 41, 44]) },
  ],
  kpi: [
    {
      label: 'KPI 1',
      points: toPoints([12000, 15500, 19800, 23400, 26200, 29900, 33100, 36364]),
    },
    { label: 'KPI 2', points: toPoints([180, 240, 310, 420, 480, 560, 650, 727]) },
  ],
  /** overlay=empty 의 예 */
  empty: [],
  unit: '백만원',
} satisfies Record<string, TimeSeries[] | string>;
